export enum ProductCollectionsEnum {
    All = "0",
    CA = "1",
    ECACCHLA = "3",
    ECACCiPSC = "4",
    GeneralCell = "5",
    HRC = "6",
    Hybridoma = "7",
    LenticuleDiscs = "8",
    MND = "9",
    NCPF = "10",
    NCPV = "11",
    NCTC = "13",
    Panels = "14"
}
